import { FunnelIcon } from '@phosphor-icons/react';

import styles from './filter-button.module.scss';

export type FilterButtonProps = {
  /** Shows the applied dot. */
  active?: boolean;
  /** Open the filter panel/drawer (owned by the consumer). */
  onClick?: () => void;
  /** When set AND active, renders the "Clear Filter" link. */
  onClear?: () => void;
  ariaLabel?: string;
  className?: string;
};

export function FilterButton({
  active = false,
  onClick,
  onClear,
  ariaLabel = 'Filter',
  className,
}: FilterButtonProps) {
  return (
    <div className={[styles.wrapper, className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className={styles.button}
        aria-label={ariaLabel}
        aria-pressed={active}
        onClick={onClick}
      >
        <FunnelIcon size={16} weight="regular" />
        {active ? <span className={styles.dot} aria-hidden /> : null}
      </button>
      {active && onClear ? (
        <button type="button" className={styles.clear} onClick={onClear}>
          Clear Filter
        </button>
      ) : null}
    </div>
  );
}
